/* rv-reviews.js: <rv-creator-row> (DESIGN-SYSTEM §9.1.8). Loads only when a rights-confirmed video renders.
   Tap-to-play (muted, one at a time), row arrows, and "Add {flavor} to cart" via /cart/add.js + Dawn's drawer. */
(() => {
  if (customElements.get('rv-creator-row')) return;
  const D = document;
  const url = (k, d) => (window.routes && window.routes[k]) || d;
  const fire = (n, detail) => D.dispatchEvent(new CustomEvent(n, { detail }));

  class RvCreatorRow extends HTMLElement {
    connectedCallback() {
      if (this.scroller) return;
      this.scroller = this.querySelector('.rv-creators__scroller');
      this.addEventListener('click', (e) => {
        const play = e.target.closest('[data-rv-play]');
        const dir = e.target.closest('[data-rv-dir]');
        if (play) this.toggle(play);
        if (dir) this.page(+dir.dataset.rvDir);
      });
      this.querySelectorAll('video').forEach((v) => {
        v.muted = true;
        ['pause', 'ended'].forEach((t) => v.addEventListener(t, () => this.sync(v, 0)));
        v.addEventListener('play', () => this.sync(v, 1));
      });
      this.querySelectorAll('form').forEach((f) => f.addEventListener('submit', (e) => this.add(e, f)));
    }

    sync(v, on) {
      const b = v.parentElement.querySelector('[data-rv-play]');
      if (!b) return;
      b.classList.toggle('is-playing', !!on);
      b.setAttribute('aria-label', b.dataset[on ? 'labelPause' : 'labelPlay']);
    }

    toggle(b) {
      const v = b.parentElement.querySelector('video');
      if (!v) return;
      if (!v.paused) return v.pause();
      this.querySelectorAll('video').forEach((o) => o !== v && o.pause());
      const p = v.play();
      if (p && p.catch) p.catch(() => this.sync(v, 0));
    }

    page(dir) {
      const s = this.scroller;
      const item = s && s.querySelector('.rv-creators__item');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(item.parentElement).columnGap) || 0;
      s.scrollBy({ left: dir * (item.offsetWidth + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    async add(e, f) {
      e.preventDefault();
      const b = f.querySelector('[type="submit"]');
      const err = f.querySelector('.rv-creators__error');
      if (!b || b.getAttribute('aria-busy') === 'true') return;
      const label = b.textContent;
      const cart = D.querySelector('cart-drawer');
      const data = new FormData(f);
      if (cart && cart.getSectionsToRender) {
        data.append('sections', cart.getSectionsToRender().map((s) => s.id));
        data.append('sections_url', location.pathname);
      }
      const SE = window.StandardEvents || {};
      const lines = SE.CartLinesUpdateEvent && SE.CartLinesUpdateEvent.createPromise();
      if (lines) {
        f.dispatchEvent(
          new SE.CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(data.get('id')), quantity: 1 }],
            promise: lines.promise,
          })
        );
      }
      b.style.minWidth = b.offsetWidth + 'px';
      b.setAttribute('aria-busy', 'true');
      b.textContent = this.dataset.busy || label;
      if (err) err.hidden = true;
      try {
        const r = await fetch(url('cart_add_url', '/cart/add') + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: data,
        });
        const res = await r.json().catch(() => ({}));
        if (!r.ok || res.status) {
          const x = new Error(res.description || res.message || '');
          x.shopify = !!(res.description || res.message);
          throw x;
        }
        if (lines) {
          fetch(url('cart_url', '/cart') + '.js')
            .then((x) => x.json())
            .then((c) => lines.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(c) }))
            .catch((x) => lines.reject(x));
        }
        fire('rv:cart-add', { items: [res], source: this });
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rv-creator-row', productVariantId: res.variant_id, cartData: res });
        }
        if (cart && res.sections) {
          if (cart.setActiveElement) cart.setActiveElement(b);
          cart.renderContents(res);
        } else {
          location.href = url('cart_url', '/cart');
        }
      } catch (x) {
        if (lines) lines.reject(x);
        const msg = x.shopify ? x.message : this.dataset.error;
        if (err) {
          err.querySelector('span').textContent = msg;
          err.hidden = false;
        }
        fire('rv:cart-error', { message: msg, source: this });
        if (SE.CartErrorEvent) {
          f.dispatchEvent(new SE.CartErrorEvent({ error: x.message || 'Network error', code: x.shopify ? 'INVALID' : 'SERVICE_UNAVAILABLE' }));
        }
      } finally {
        b.removeAttribute('aria-busy');
        b.style.minWidth = '';
        b.textContent = label;
      }
    }
  }

  customElements.define('rv-creator-row', RvCreatorRow);
})();
